<template>
  <d-navbar-nav class="">
    <li class="nav-item dropdown dash-dropdown">
      <a class="nav-link nav-link-icon text-center" v-d-toggle.search>
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">search</i>
          <!-- <d-badge pill theme="danger">2</d-badge> -->
        </div>
      </a>
      <d-collapse id="search" class="dropdown-menu dropdown-menu-small">
        <d-dropdown-item>
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">&#xE6E1;</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Analytics</span>
            <p>Your website’s active users count increased by <span class="text-success text-semibold">28%</span> in the last week. Great job!</p>
          </div>
        </d-dropdown-item>
        <d-dropdown-item href="#">
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">&#xE8D1;</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Sales</span>
            <p>Last week your store’s sales count decreased by <span class="text-danger text-semibold">5.52%</span>. It could have been worse!</p>
          </div>
        </d-dropdown-item>
        <d-dropdown-item class="notification__all text-center">View all Notifications</d-dropdown-item>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
export default {
  name: 'navbar-search',
};
</script>

<style>
  .nav-link:hover {
    cursor: pointer;
  }
</style>
